import { useCallback } from 'react'

import { useAppDispatch } from '@/store'
import { unwrapResult } from '@reduxjs/toolkit'

import { validatePhoneNumbers } from '@/features/domain/order/actions/validatePhoneNumbers'

export const useValidatePhoneNumber = () => {
  const dispatch = useAppDispatch()

  const validationFunction = useCallback<(phoneNumber: string) => Promise<boolean>>(
    async (phoneNumber: string) => {
      const thunkResult = await dispatch(validatePhoneNumbers([phoneNumber]))

      if (validatePhoneNumbers.fulfilled.match(thunkResult)) {
        const valid = unwrapResult(thunkResult)[phoneNumber]

        return valid
      }

      throw new Error(thunkResult.payload?.message ?? 'Internal error')
    },
    [dispatch],
  )

  return validationFunction
}
